// 初始化数据
// 用户信息

import home from '../page/home/redux/modal';
import editPwd from '../page/editPwd/redux/modal';
import orderNotice from '../page/orderNotice/redux/modal';
import orderNoticeDes from '../page/orderNoticeDes/redux/modal';
import printDocument from '../page/printDocument/redux/modal';
import orderAccept from '../page/orderAccept/redux/modal';
import orderAcceptDes from '../page/orderAcceptDes/redux/modal';
import orderAcceptPrint from '../page/orderAcceptPrint/redux/modal';
import returnNotice from '../page/returnNotice/redux/modal';
import returnNoticeDes from '../page/returnNoticeDes/redux/modal';
import returnNoticePrint from '../page/returnNoticePrint/redux/modal';
import returnFrom from '../page/returnFrom/redux/modal';
import returnFromDes from '../page/returnFromDes/redux/modal';
import returnFromPrint from '../page/returnFromPrint/redux/modal';
import reconciliationManagement from '../page/reconciliationManagement/redux/modal';
import entryAndCore from '../page/entryAndCore/redux/modal';
import accountManagement from '../page/accountManagement/redux/modal';
import userRegistered from '../page/userRegistered/redux/modal';
import findPhoneNumbered from '../page/findPhoneNum/redux/modal';

// 电子签章业务
import businessQueries from '../page/businessQueries/redux/modal';
import changeQueries from '../page/changeQueries/redux/modal';
import applyApproval from '../page/applyApproval/redux/modal';
import phoneChangeApproval from '../page/phoneChangeApproval/redux/modal';
import businessApplications from '../page/businessApplications/redux/modal';
import editPhone from '../page/editPhone/redux/modal';

// 对账-报表查询
import signatureStatement from '../page/signatureStatement/redux/modal';
import unpaidAmount from '../page/unpaidAmount/redux/modal'; //  未付款金额列表
import documentFreezing from '../page/documentFreezing/redux/modal'; //供应商单据冻结
import vendorPayment from '../page/vendorPayment/redux/modal'; //  供应商未付款单查询
import reconciliationInformation from '../page/reconciliationInformation/redux/modal'; //  对账信息查询
import invoiceManagement from '../page/invoiceManagement/redux/modal';
import expenseQuery from '../page/expenseQuery/redux/modal'; //  供应商费用单查询
// 预约送货
import reserveDeliver from '../page/reserveDeliver/redux/modal';

//bbc
import bbcNoDeliveryArea from '../page/bbcNoDeliveryArea/redux/modal';
import bbcOrderManageMent from '../page/bbcOrderManageMent/redux/modal'; //bbc订单管理
import bbcOrderDetail from '../page/bbcOrderDetail/redux/modal'; //bbc订单详情
import bbcPerformanceScope from '../page/bbcPerformanceManagement/Scope/redux/modal';
import bbcPerformanceExpressSearch from '../page/bbcPerformanceManagement/expressSearch/redux/modal';
import bbcPerformanceHoliday from '../page/bbcPerformanceManagement/holiday/redux/modal';
import bbcGoodsManageMent from '../page/bbcGoodsManagement/redux/modal';
import bbcGoodsChange from '../page/bbcGoodsChange/redux/modal';
import bbcGoodsView from '../page/bbcGoodsView/redux/modal';

import yhLifeStatement from '../page/yhLifeFreightStatement/redux/modal';
import sortingDataQueryReducerStatement from '../page/sortingDataQuery/redux/modal';
import PurchaseOrderMonitoring from '../page/PurchaseOrderMonitoring/redux/modal'; //采购单监控

import ApplyBilling from '../page/ApplyBilling/redux/modal'; //  开票申请
import InvoiceRecord from '../page/InvoiceRecord/redux/modal'; //  开票申请记录
import BillingInquiry from '../page/BillingInquiry/redux/modal'; //  开票查询
import reconciliationCommission from '../page/reconciliationCommission/redux/modal'; //  代售业务对账

import bbcGoodsChangeNew from '../page/bbcGoodsChangeNew/redux/modal'; //  商品编辑新
import NewbbcGoodsView from '../page/NewbbcGoodsView/redux/modal'; //  商品详情新
import bbcGoodsManagementNew from '../page/bbcGoodsManagementNew/redux/modal'; //  BBC联营商品管理

export const previewData = '未登录'; // 登录状态
export const userInfos = {};
export const initState = {
  bbcGoodsManagementNew,
  NewbbcGoodsView,
  bbcGoodsChangeNew,
  previewData,
  userInfos,
  home,
  editPwd,
  orderNotice,
  orderNoticeDes,
  printDocument,
  orderAccept,
  orderAcceptDes,
  orderAcceptPrint,
  returnNotice,
  returnNoticeDes,
  returnNoticePrint,
  returnFrom,
  returnFromDes,
  returnFromPrint,
  reconciliationManagement,
  entryAndCore,
  accountManagement,
  userRegistered,
  findPhoneNumbered,
  // 电子签章业务
  businessQueries,
  changeQueries,
  applyApproval,
  phoneChangeApproval,
  businessApplications,
  editPhone,
  PurchaseOrderMonitoring,

  // 对账-报表查询
  signatureStatement,
  unpaidAmount,
  documentFreezing,
  vendorPayment,
  reconciliationInformation,
  invoiceManagement,
  expenseQuery,
  reserveDeliver,
  //bbc
  bbcNoDeliveryArea,
  bbcOrderManageMent,
  bbcOrderDetail,
  bbcPerformanceScope,
  bbcPerformanceExpressSearch,
  bbcPerformanceHoliday,
  bbcGoodsManageMent,
  bbcGoodsChange,
  bbcGoodsView,
  yhLifeStatement,
  sortingDataQueryReducerStatement,
  ApplyBilling,
  InvoiceRecord,
  BillingInquiry,
  reconciliationCommission,
};
